import React from "react"
import { Redirect } from "react-router-dom"

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

//page
// import Users from "../pages/Users";
// import RamNaam from '../pages/RamNaam';
import Setting from "../pages/Setting";
import Notification from "../pages/Notification";
import Blog from "../pages/Blog/Blog";
import Screen from "../pages/Screen";
// Testimonials
import Contact from "../pages/Contact";
import RajmithContact from "../pages/Contact/RajmithUs";
import RajmithUsSub from "../pages/Contact/RajmithUsSub";
import HourlytechjobsContactus from "../pages/Contact/HourlytechjobsContactus";
import AddBlogs from '../pages/Blogs/AddBlog';
import Cat from "../pages/Gallery/Category";
import Upload_Photo from "../pages/Gallery/Upload_Photo";
import Teams from "../pages/Teams";
import Subcs from "../pages/Subscription";
import Location from "../pages/Location";

// Rajmith
import Client from "../pages/Client";
import Testimonial from "../pages/Testimonials";
import Tags from "../pages/Tags";
import Tech from "../pages/Project/Tech";
import Type from "../pages/Project/Type";
import ImageStore from "../pages/ImageStore";
import AnimStore from "../pages/AnimStore";
import AddProject from "../pages/Project/AddProject";
import AddJobs from "../pages/Jobs";
import Seo from "../pages/Seo";
import SocialMedia from "../pages/SocialMedia";
import Career from "../pages/Career/Cards";
import HourlytechjobsCareer from "../pages/Contact/HourlytechjobsCareer";

const userRoutes = [
  { path: "/dashboard", component: Dashboard },
  // { path: '/dashboard2', component: Dashboard2 },
  // { path: "/users", component: Users },
  // { path: "/ram-naam", component: RamNaam },
  // { path: "/popup", component: Popup },
  // { path: "/banner", component: Banner },
  // { path: "/notification-data", component: NotificationData },
  { path: "/setting", component: Setting },
  // { path: "/brand", component: Brand },
  // { path: "/product", component: Product },
  { path: "/contact_us", component: Contact },
  { path: "/career", component: Career },
  // { path: "/property", component: Property },
  // { path: "/property/:id", component: Property },
  // { path: "/anayltic", component: Anayltics },
  // { path: "/anayltic/user/:id", component: Anayltics },
  // { path: "/anayltic/screen/:id", component: Anayltics },
  // { path: "/anayltic/raam/:id", component: Anayltics },
  // { path: "/ads", component: Ads },
  // { path: '/blog-author', component: BlogAuthor },
  // { path: '/blog-category', component: BlogCat },
  { path: '/blog', component: Blog },
  // { path: '/share-data', component: ShareData },
  // { path: '/admin', component: Admin },
  // { path: '/ram-naam-winner', component: RaamWinner },

  // Brand Street

  { path: '/contact_us', component: Contact },
  { path: '/contact-us', component: RajmithContact },
  { path: '/rajmith-us-sub', component: RajmithUsSub },
  { path: '/hourly-tech-jobs-contact', component: HourlytechjobsContactus },
  { path: '/hourly-tech-jobs-career', component: HourlytechjobsCareer },
  { path: "/blogs", component: AddBlogs },
  { path: "/tags", component: Tags },
  { path: "/testimonials", component: Testimonial },
  { path: '/gallery-category', component: Cat },
  { path: '/gallery-upload', component: Upload_Photo },
  { path: '/client', component: Client },
  { path: '/image-store', component: ImageStore },
  { path: '/anim-image', component: AnimStore },
  { path: '/teams', component: Teams },
  { path: '/subcs', component: Subcs },
  { path: '/location', component: Location },
  { path: "/web-pages", component: Screen },
  { path: '/seo', component: Seo },
  { path: '/technologies', component: Tech },
  { path: '/type', component: Type },
  { path: '/project', component: AddProject },
  { path: '/jobs', component: AddJobs },
  { path: "/social-media", component: SocialMedia },

  //Notification

  { path: "/notification", component: Notification },
  // //profile
  { path: "/profile", component: UserProfile },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes = [

  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  // { path: "/pages-404", component: Pages404 },
  // { path: "/pages-500", component: Pages500 },

  // Authentication Inner
  { path: "/pages-login", component: Login1 },
  { path: "/page-recoverpw", component: Recoverpw },
  { path: "/auth-lock-screen", component: LockScreen },
]

export { userRoutes, authRoutes }